// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2KWJr","buttons":"SendReceipts_buttons__1qkEE","email":"SendReceipts_email__1nCJi","bookApptTitle":"SendReceipts_bookApptTitle__2mnQ5"};